// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3OAY4","selects":"Documents_selects__AJJKX"};